import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StorageEnum } from '../../utils/enumerators/Storage.enum';
import { getBranches, getAccessToken } from '../../utils/services/gitlab-service';
import PageDefault from '../PageDefault/PageDefault';

import './GitLabCallback.scss';
import { getGitLabTokens } from '../../utils/services/service';

function GitLabCallback() {
	const history = useNavigate();

	function goToHome() {
		history('/');
	}

	const STATE = {
		DEFAULT: 1,
		SUCCESS: 2,
		ERROR: 3,
	};
	const [state, setState] = useState(STATE.DEFAULT);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams && urlParams.get('code')) {
			getAccessToken(urlParams.get('code'))
				.then((response) => {
					const callbackPage = localStorage.getItem(Storage.CALLBACK_PAGE);

					// adquire o personal token para testar a permissão do projeto
					getGitLabTokens()
						.then(() => {
							setState(STATE.SUCCESS);
							setTimeout(() => {
								if (callbackPage) {
									history(callbackPage);
									localStorage.removeItem(Storage.CALLBACK_PAGE);
								} else {
									goToHome();
								}
							}, 1500);
						})
						.catch(() => {
							setState(STATE.ERROR);
						});
				})
				.catch((e) => {
					setState(STATE.ERROR);
				});
		} else {
			goToHome();
		}
	}, []);

	return (
		<PageDefault>
			<div className="message centered">
				{state == STATE.DEFAULT && <span>Carregando...</span>}
				{state == STATE.SUCCESS && (
					<>
						<span>Login realizado com sucesso!</span>
					</>
				)}
				{state == STATE.ERROR && <span>Você não possui permissão para este projeto.</span>}
			</div>
		</PageDefault>
	);
}

export default GitLabCallback;
